<zuper-drawer class="border-l border-gray-300 shadow-none route-form" [name]="drawerName" [mode]="'over'"
        [position]="'right'" [transparentOverlay]="false" (openedChanged)="drawerOpenedChanged($event)"
        [hideOnClickOutside]="false" [fixed]="true">
            <div class="drawer-content w-full">
                <div class="route-form-header w-full">
                    <div class="relative w-full px-3 py-2 bg-accent-100 dark:bg-accent-700 z-0">
                        <div class="flex items-center justify-between w-full">
                            <h5 class="text-base font-semibold px-2.5 text-xl">
                                {{options?.header | translate}}
                            </h5>
                            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                                matTooltipPosition="above" tabindex="0" (click)="closeDrawer()">
                                <mat-icon [svgIcon]="'heroicons_solid:x'"></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="route-main-container h-full zuper-scrollbar"  *ngIf="currentFormState === 'PRIMARY'">
                     <!-- Time Zone Alert -->
                    <div class="rounded-md bg-blue-50 m-4 px-4 py-3 border-l-8 border-blue-700" *ngIf="parentModule === 'dispatch'">
                        <div class="flex items-center">
                            <div class="flex-shrink-0"><em class="ti ti-alert-circle text-blue-700 text-2xl"></em></div>
                            <div class="ml-3 flex-1 md:flex md:justify-between">
                                <p class="text-base text-blue-700">{{'new.route.time_zone.content' | translate}}
                                    {{timezoneDisplayName}}, <span class="font-medium">{{timezone}}</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="route-primary-form">
                        <div class="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                            <!-- Title -->                                                
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"text.route_name" | translate}} <span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words">
                                        <input 
                                        type="text" 
                                        name="title" 
                                        id="title" 
                                        [formControl]="routeTitle"
                                        class="mt-1  mt-4 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                                        placeholder="{{ 'placeholder.route_name' | translate}}"
                                        >  
                                        <p class="text-red-500 text-base mt-1" *ngIf="hasTitleError()">{{hasTitleError() | translate}}</p>        
                                </div>
                            </div>
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"text.route_color" | translate}}
                                </div>
                                <div class="col-span-4 break-words">
                                    <input type="color" class="cursor-pointer"
                                    list="presetColors" placeholder="Primary Color" [formControl]="color">
                                    <datalist id="presetColors">
                                        <option value="#1abc9c">#1abc9c</option>/&gt;
                                        <option value="#27ae60">#27ae60</option>
                                        <option value="#3498db">#3498db</option>
                                        <option value="#8e44ad">#8e44ad</option>
                                        <option value="#e67e22">#e67e22</option>
                                        <option value="#e74c3c">#e74c3c</option>
                                        <option value="#2c3e50">#2c3e50</option>
                                    </datalist>
                                </div>
                            </div>
                            <!-- Mode of Transport -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"text.mode_of_transport" | translate}} <span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words">
                                    <editable>
                                        <ng-template viewMode>
                                            <em class="ti ti-user text-xl mr-1"></em>
                                            <span class="border-b border-dotted border-gray-500 text-base" (click)="openMode()">
                                                {{ transportModeObj[transportMode?.value] | translate}}
                                            </span>
                                        </ng-template>
                                    
                                        <ng-template editMode>
                                            <mat-form-field appearance="fill" class="w-full">
                                                <mat-select editableOnEnter #modeSelect editableOnEscape class="text-base" [formControl]="transportMode">
                                                    <mat-option class="text-base" value="" disabled> {{"route.choose_mode_of_transport" | translate}}</mat-option>
                                                    <mat-option class="text-base" [value]="'CAR'"> {{"route.choose_mode_of_transport.car_semi_truck" | translate}}</mat-option>
                                                    <mat-option class="text-base" [value]="'TRUCK'"> {{"route.choose_mode_of_transport.truck" | translate}}</mat-option>
                                                    <mat-option class="text-base" [value]="'PEDESTRIAN'"> {{"route.choose_mode_of_transport.pedestrian" | translate}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </ng-template>
                                    </editable>
                                </div>
                            </div>
                            <!-- Route Optimisation type -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"text.route_type" | translate}} <span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words">
                                    <editable>
                                        <ng-template viewMode>
                                            <em class="ti ti-route text-xl mr-1"></em>
                                            <span class="border-b border-dotted border-gray-500 text-base" (click)="openOptimisation()">
                                                {{ routeOptimisationObj[routeOptimisation?.value] | translate}}
                                            </span>
                                        </ng-template>
                                    
                                        <ng-template editMode>
                                            <mat-form-field appearance="fill" class="w-full">
                                                <mat-select editableOnEnter #optimisationSelect editableOnEscape class="text-base" [formControl]="routeOptimisation">
                                                    <mat-option class="text-base" value="" disabled> {{"route.route_type.default" | translate}}</mat-option>
                                                    <mat-option class="text-base" [value]="'FASTEST'"> {{"route.fastest_travel_time" | translate}}</mat-option>
                                                    <mat-option class="text-base" [value]="'SHORTEST'"> {{"route.shortest_distance" | translate}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </ng-template>
                                    </editable>
                                </div>
                            </div>

                            <!-- Start Location -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-start text-base mt-2 font-medium text-gray-700">
                                    {{"text.start_location" | translate}} <span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words">
                                        <input id="start_location_street" type="text" [formControl]="startLocationStreet" (change)="startLocationChange()"
                                            placeholder="{{'contactInfo.field.street.placeholder' | translate}}" googleMapsAutocomplete
                                            [canTruncate]="true"
                                            (autocompleteSelected)="onAutocompleteSelected($event)"
                                            class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base">
                                        <p class="text-red-500 text-base mt-2 primary-font" *ngIf="showStartLocationError()">
                                            {{'text.field_is_required' | translate}}
                                        </p>
                                    <div class="h-34 mt-3">
                                        <location-preview *ngIf="showLocation" [options]="mapOptions"></location-preview>
                                    </div>
                                </div>
                            </div>
                            <!-- End Location -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-start text-base mt-2 font-medium text-gray-700">
                                    {{"text.end_location" | translate}}
                                </div>
                                <div class="col-span-4 break-words">
                                    <input id="end_location_street" type="text" [formControl]="endLocationStreet" (change)="endLocationChange()"
                                            placeholder="{{'contactInfo.field.street.placeholder' | translate}}" googleMapsAutocomplete
                                            [canTruncate]="true"
                                            (autocompleteSelected)="onEndLocationSelected($event)"
                                            class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base">
                                    <div class="h-34 mt-3">
                                        <location-preview *ngIf="showEndLocation" [options]="mapEndOptions"></location-preview>
                                    </div>
                                </div>
                            </div>

                            <!-- Departure -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"text.departure" | translate}} <span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words flex flex-col">
                                    <input 
                                        readonly
                                        type="text"    
                                        [ngxMatDatetimePicker]="routeDatePicker"
                                        (click)="setTime(routeDatePicker); routeDatePicker.open();"
                                        [datePickerFormat]="dateFormat"
                                        [formControl]="departure"
                                        [min]="routeDepartureMinDate"
                                        class="mt-1 block cursor-pointer field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                    >
                                    <!-- <mat-datepicker  #routeDatePicker></mat-datepicker> -->
                                    <ngx-mat-datetime-picker #routeDatePicker [showSpinners]="true"
                                        [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
                                        [touchUi]="false" [enableMeridian]="showMeridian" [disableMinute]="false">
                                        <ngx-mat-datepicker-actions>
                                            <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                                        </ngx-mat-datepicker-actions>
                                    </ngx-mat-datetime-picker>
                                    <p class="text-red-500 text-base mt-1" *ngIf="departure.hasError('min')">{{'request.date.past.error.message' | translate}}</p>
                                </div>
                            </div>

                            <!-- Duration -->
                            <div class="grid grid-cols-6 gap-4 px-6 py-5">
                                <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-700">
                                    {{"route.label.duration" | translate}}<span class="mandatory-field" >*</span> 
                                </div>
                                <div class="col-span-4 break-words">
                                    <div class="flex justify-center items-center space-x-2">
                                        <input 
                                            type="text" 
                                            name="duration" 
                                            [formControl]="duration"
                                            id="prefix" 
                                            class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                                            placeholder="{{ 'recurrence.placeholder.duration' | translate}}"
                                        > 
                                        <span class="ml-2">
                                            {{"route.hours" | translate}}
                                        </span>
                                    </div>
                                    <p class="text-red-500 text-base mt-1" *ngIf="hasDurationError()">{{hasDurationError() | translate}}</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="route-main-container zuper-scrollbar"  *ngIf="currentFormState === 'REORDER'">
                    <!-- Time Zone Alert -->
                    <div class="rounded-md bg-blue-50 m-4 px-4 py-3 border-l-8 border-blue-700" *ngIf="parentModule === 'dispatch'">
                        <div class="flex items-center">
                            <div class="flex-shrink-0"><em class="ti ti-alert-circle text-blue-700 text-2xl"></em></div>
                            <div class="ml-3 flex-1 md:flex md:justify-between">
                                <p class="text-base text-blue-700">{{'new.route.time_zone.content' | translate}}
                                    {{timezoneDisplayName}}, <span class="font-medium">{{timezone}}</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="route-job-container">
                        <h5 class="my-3 flex items-center text-lg font-semibold text-gray-700 my-3">
                            <span class="ml-3">{{"text.jobs" | translate}}</span>
                        </h5>
                    </div>
                    <div class="m-4 border-l" [ngStyle]="{'border-left-color': preference?.scheduler?.secondary_color || color?.value}">
                        <div class="p-3 pt-4 border border-l-8 mb-6"
                            *ngIf="startLocationStreet.value"
                            [ngStyle]="{
                                'background': preference?.scheduler?.primary_color,
                                'border-left-color': preference?.scheduler?.secondary_color || color?.value
                            }"
                        >
                            <div>
                                <p class="text-base font-semibold">{{'text.start_location' | translate}}</p>
                                <p class="text-base" *ngIf="startLocationStreet?.value">{{startLocationStreet?.value}}</p>
                                <p class="text-base" *ngIf="startLocationName?.value">{{startLocationName?.value}}</p>
                            </div>
                        </div>
                        <app-job-reorder [jobs]="jobs" [routeDetails]="data" (reorderChange)="onReorderChange($event)" *ngIf="jobs?.length" [showRouteAlert]="showRouteAlert" [timezone]="timezone"></app-job-reorder>
                        <p 
                            (click)="toggleJob();"
                            class="text-primary text-base cursor-pointer py-5 flex justify-center border border-gray-300" [ngClass]="{' border-t-0': jobs?.length > 0}">
                            <i class="ti ti-plus mr-2 mt-0.5"></i> <span>{{"route.add.job" | translate}}</span>
                        </p>
                        <div class="p-3 pt-4 border border-l-8 mt-6"
                            *ngIf="endLocationStreet?.value"
                            [ngStyle]="{
                                'background': preference?.scheduler?.primary_color,
                                'border-left-color': preference?.scheduler?.secondary_color || color?.value
                            }"
                        >
                        <div>
                            <p class="text-base font-semibold">{{'text.end_location' | translate}}</p>
                            <p class="text-base" *ngIf="endLocationStreet?.value">{{endLocationStreet?.value}}</p>
                            <p class="text-base" *ngIf="endLocationName?.value">{{endLocationName?.value}}</p>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="route-footer h-16">
                    <div class="w-full px-4 flex justify-between items-center gap-4 h-full routeFormActionBtn">
                        <button mat-stroked-button
                            *ngIf="currentFormState === 'PRIMARY'"
                            (click)="closeDrawer()"
                            class="h-10 min-h-10 px-6 w-full items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                            {{'cancel.text' | translate}}
                        </button>
                        <button type="button"
                            *ngIf="options?.state === 'clone'"
                            (click)="getFormValue()" 
                            class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                            <span >{{'text.clone' | translate}}</span>
                        </button>
                        <button type="button"
                            *ngIf="currentFormState === 'PRIMARY' && options?.state !== 'clone'"
                            (click)="initReorder()" 
                            class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                            {{'ppm.form.next.btn_text' | translate}}
                        </button>
                        <button mat-stroked-button
                            *ngIf="currentFormState === 'REORDER' && options?.state !== 'clone'"
                            (click)="currentFormState='PRIMARY'" 
                            class="h-10 min-h-10 px-6 w-full items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                            {{'ppm.form.previous.btn_text' | translate}}
                        </button>
                        <button type="button"
                            *ngIf="currentFormState === 'REORDER' && options?.state !== 'clone'"
                            (click)="getFormValue()" [disabled]="blockCreateRoute"
                            class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                            <span class="text-white" *ngIf="options?.state === 'new' || options?.state === 'clone'" >{{'create' | translate}}</span>
                            <span class="text-white" *ngIf="options?.state === 'edit'">{{'update' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
</zuper-drawer>


<data-picker 
    (eventEmitter)="dataPickerEventHandler($event)"
    [openPicker]="openJob" 
    [pickerDrawerName]="'route_form'"
    [module]="'JOB'" 
    [options]="jobPickerOptions"
    [filter]="getPickerFilter()"
    [timezone]="timezone"
></data-picker>
